<template>
    <div class="member-edit">
       <el-form-custom class="form mt2" ref="memberEdit" :model="member" :rules="rules">
            <table class="table-register">
                <tr>
                    <th id="name" class="column-label required">{{ $t('member.name') }}</th>
                    <td class="column-input">
                      <div class="d-flex">
                        <el-form-item-custom class="w-45p w-95p-m mr-auto" prop="lastName"><input type="text" v-model="member.lastName" placeholder="姓" class="input" :disabled="disabled || formDisabled"></el-form-item-custom>
                        <el-form-item-custom class="w-45p w-95p-m" prop="firstName"><input type="text" v-model="member.firstName" placeholder="名" class="input" :disabled="disabled || formDisabled"></el-form-item-custom>
                      </div>
                    </td>
                </tr>
                <tr>
                    <th id="name-kana" class="column-label required">{{ $t('member.name_kana') }}</th>
                    <td class="column-input">
                      <div class="d-flex">
                        <el-form-item-custom class="w-45p w-95p-m mr-auto" prop="lastNameKana"><input type="text" v-model="member.lastNameKana" placeholder="セイ" class="input" :disabled="disabled || formDisabled"></el-form-item-custom>
                        <el-form-item-custom class="w-45p w-95p-m" prop="firstNameKana"><input type="text" v-model="member.firstNameKana" placeholder="メイ" class="input" :disabled="disabled || formDisabled"></el-form-item-custom>
                      </div>
                    </td>
                </tr>
                <tr>
                    <th id="gender" class="column-label required">{{ $t('member.gender') }}</th>
                    <td class="column-input">
                        <el-form-item-custom prop="gender">
                          <el-radio-group v-model="member.gender">
                            <el-radio :key="1" :label="'1'" :disabled="disabled || formDisabled">{{ $t('commons.male') }}</el-radio>
                            <el-radio :key="2" :label="'2'" :disabled="disabled || formDisabled">{{ $t('commons.female') }}</el-radio>
                          </el-radio-group>
                        </el-form-item-custom>
                    </td>
                </tr>
                <tr>
                    <th id="phone" class="column-label">{{ $t('member.phone') }}</th>
                    <td class="column-input max-width-300 tel">
                        <el-form-item-custom prop="phone">
                          <input type="text" class="input mr-3" v-model="member.phone" :disabled="disabled || formDisabled" placeholder="03-xxxx-xxxx">
                          <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
                        </el-form-item-custom>
                    </td>
                </tr>
                <tr>
                    <th id="birthday-tittle" class="column-label required">{{ $t('member.birthday') }}</th>
                    <td id="birthday">
                        <el-form-item-custom prop="birthday">
                          <date-select v-model="member.birthday" :disabled="disabled || formDisabled"></date-select>
                        </el-form-item-custom>
                    </td>
                </tr>
                <tr>
                    <th id="zip-code" class="column-label">{{ $t('member.zip_code') }}</th>
                    <td class="column-input max-width-220">
                        <el-form-item-custom prop="zipCode">
                          <zip-code-input class="d-inline-block mr-3" v-model="member.zipCode" :disabled="disabled || formDisabled"></zip-code-input>
                        </el-form-item-custom>
                    </td>
                </tr>
                <tr>
                    <th id="prefecture" class="column-label required">{{ $t('member.prefecture') }}</th>
                    <td class="column-input max-width-220">
                      <el-form-item-custom prop="prefecture">
                        <prefecture-select
                          v-model="member.prefecture"
                          :prefectureMaster="prefectureMaster"
                          :disabled="formDisabled"
                          class="w-100"
                          ></prefecture-select>
                      </el-form-item-custom>
                    </td>
                </tr>
                <tr>
                    <th id="address" class="column-label">{{ $t('member.address') }}</th>
                    <td class="column-input max-width-400">
                        <el-form-item-custom prop="address"><input type="text" v-model="member.address" :disabled="formDisabled"></el-form-item-custom>
                    </td>
                </tr>
                <tr>
                    <th id="use-mail-magazine" class="column-label required" style="min-width: 280px">{{ $t('member.use_mail_magazine') }}</th>
                    <td class="column-input max-width-220">
                      <el-radio-group v-model="member.useMailMagazine">
                        <el-radio :key="true" :label="true" :disabled="formDisabled">{{ $t('commons.yes') }}</el-radio>
                        <el-radio :key="false" :label="false" :disabled="formDisabled">{{ $t('commons.no') }}</el-radio>
                      </el-radio-group>
                    </td>
                </tr>
            </table>
             <div v-if="hasContactId" style="font-size: 14px">※ご登録内容は、レガシィ側が管理している情報へ変更する場合がございます。あらかじめご了承下さい。</div>
            <div class="button">
                <div class="mt2 text-center">
                    <div v-if="isComplete">
                        <div class="complete-wording">
                            変更が完了しました。
                        </div>
                        <br>
                        <el-button type="primary" @click="$router.go(-1)">戻る</el-button>
                    </div>
                    <div v-else-if="isError===false&&isConfirm===true">
                        <div class="confirm-wording">
                            上記内容で登録します。よろしいですか？
                        </div>
                        <br>
                        <el-button type="primary" @click="cancelSubmitForm">戻る</el-button>
                        <el-button class="gtm_member_henkou_member" @click="handleEditInformMember"><span class="gtm_member_henkou_member">{{ $t('commons.edit') }}</span></el-button>
                    </div>
                    <div v-else>
                        <el-button class="gtm_member_henkou_member" @click="submitForm" ><span class="gtm_member_henkou_member">{{ $t('commons.edit')  }}</span></el-button>
                    </div>
                </div>
            </div>
        </el-form-custom>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ZipCodeInput from '../../../../components/common/ZipCodeInput'
    import DateSelect from '../../../../components/common/DateSelect'
    import ContactApi from '@/api/contact/contact-cl'
    import moment from 'moment'
    import memberApi from '@/api/member/member-client.js'
    import { SET_UPDATE_AUTH_CLIENT } from '@/store/mutations.type'
    import messageFormErrUtil from './messageFormErrUtil'
    import PrefectureSelect from '@/components/common/PrefectureSelect'

    export default {
      name: 'MemberEdit',
      mixins: [messageFormErrUtil],
      components: {
          DateSelect,
          ZipCodeInput,
          PrefectureSelect
        },
      data () {
            const validateDate = (rule, value, callback) => {
              if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
                callback(new Error('正しい日付を選択してください'))
              } else {
                callback()
              }
            }
            return {
                member: {
                    loginId: '',
                    password: '',
                    lastName: '',
                    passwordConfirm: '',
                    firstName: '',
                    lastNameKana: '',
                    firstNameKana: '',
                    phone: '',
                    zipCode: '',
                    prefecture: '',
                    address: '',
                    gender: '',
                    birthday: '',
                    useMailMagazine: true
                },
                rules: {
                    lastName: [
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name') }), trigger: 'blur' },
                        { max: 50, message: '50文字以内で入力してください' }
                    ],
                    firstName: [
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name') }), trigger: 'blur' },
                        { max: 50, message: '50文字以内で入力してください' }
                    ],
                    lastNameKana: [
                        { pattern: /^[ァ-ンヴー]+$/, message: '全角カタカナで入力してください' },
                        { max: 50, message: '50文字以内で入力してください' },
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name_kana') }), trigger: 'blur' }
                    ],
                    firstNameKana: [
                        { pattern: /^[ァ-ンヴー]+$/, message: '全角カタカナで入力してください' },
                        { max: 50, message: '50文字以内で入力してください' },
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name_kana') }), trigger: 'blur' }
                    ],
                    gender: [
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.gender') }), trigger: 'blur' }
                    ],
                    phone: [
                        { required: false, pattern: /^(?:\d{2}-\d{4}|\d{3}-\d{3}|\d{4}-\d{2}|\d{5}-\d)-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.phone') }), trigger: 'blur' }
                    ],
                    zipCode: [
                        { required: false, pattern: /^[0-9]{3}-[0-9]{4}$/, message: this.$t('rules.zip_code'), trigger: 'blur' }
                    ],
                    birthday: [
                      { validator: validateDate, trigger: 'blur' }
                    ],
                    prefecture: [
                        { required: true, message: this.$t('rules.no_select', { key: this.$t('member.prefecture') }), trigger: 'blur' }
                    ],
                    address: [
                        { required: false, max: 200, message: '200文字以内で入力してください', trigger: 'blur' }
                    ]
                },
                disabled: false,
                formDisabled: false,
                isConfirm: false,
                isError: false,
                needCheck: false,
                isComplete: false,
                hasContactId: false,
                prefectureMaster: []
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        created () {
            this.loadMemberInfo()
            this.loadPrefecture()
        },
        beforeUpdate () {
            if (this.needCheck) {
                this.$refs['memberEdit'].validate((valid) => {
                    if (valid) {
                        this.isError = false
                    } else {
                        this.isError = true
                    }
                })
            }
        },
        methods: {
            formatDate (date, format = 'YYYY-MM-DD', defaultValue = null) {
                return date !== null && date !== undefined ? moment(date).format(format) : defaultValue
            },
            async submitForm () {
                this.needCheck = true
                this.$refs['memberEdit'].validate((valid) => {
                    if (valid) {
                        this.isError = false
                        this.formDisabled = true
                        this.isConfirm = true
                    } else {
                        this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                    }
                })
            },
            cancelSubmitForm () {
                this.formDisabled = false
                this.isConfirm = false
            },
            handleEditInformMember () {
                this.$refs['memberEdit'].validate((valid) => {
                    if (valid) {
                        this.formDisabled = true
                        let birthday = this.formatDate(this.member.birthday)
                        let dataRequest = {
                            'lastName': this.member.lastName,
                            'firstName': this.member.firstName,
                            'lastNameKana': this.member.lastNameKana,
                            'firstNameKana': this.member.firstNameKana,
                            'phone': this.member.phone,
                            'zipCode': this.member.zipCode,
                            'prefecture': this.member.prefecture,
                            'address': this.member.address,
                            'gender': this.member.gender.toString(),
                            'birthday': birthday,
                            'useMailMagazine': this.member.useMailMagazine
                        }
                        ContactApi.editInformMember(dataRequest).then(() => {
                            this.$msgbox({
                                title: '更新しました。',
                                showClose: true,
                                center: true,
                                confirmButtonClass: 'btn-msg-box'
                            })
                            setTimeout(() => { this.$msgbox.close() }, 2000)
                            this.loadCurrentUserInfo(dataRequest)
                            this.isComplete = true
                        }).catch(err => {
                            this.showMsgError(this, 'memberEdit', err.response.data.message)
                        })
                    } else {
                        this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                    }
                })
            },
            async loadMemberInfo () {
                this.member = await memberApi.getLoginUserInfo()
                if (this.member.contactId !== null) this.hasContactId = true
                if (this.member.gender !== '1' && this.member.gender !== '2') {
                   this.member.gender = null
                }
            },
            loadCurrentUserInfo (data) {
                let clone = Object.assign({}, this.currentUser)
                for (let [key] of Object.entries(data)) {
                    clone[key] = data[key]
                }
                this.$store.commit(SET_UPDATE_AUTH_CLIENT, clone)
            },
            async loadPrefecture () {
              const res = await ContactApi.getInformPrefectureMaster()
              this.prefectureMaster = res.data.data
            },
            alertMessage (message, title) {
                this.$alert(message, title, {
                    confirmButtonText: this.$t('commons.ok')
                })
            }
        }
    }
</script>

<style>
    @import 'member_register.css';
    .member-edit {
        padding-bottom: 2em;
    }
</style>
